// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import { createEnum } from "@cartographerio/util";

export type Thames21RapidAppraisalBeachGrade =
  | "A"
  | "B+"
  | "B"
  | "B-"
  | "C+"
  | "C"
  | "C-"
  | "D";

const A: Thames21RapidAppraisalBeachGrade = "A";
const BPlus: Thames21RapidAppraisalBeachGrade = "B+";
const B: Thames21RapidAppraisalBeachGrade = "B";
const BMinus: Thames21RapidAppraisalBeachGrade = "B-";
const CPlus: Thames21RapidAppraisalBeachGrade = "C+";
const C: Thames21RapidAppraisalBeachGrade = "C";
const CMinus: Thames21RapidAppraisalBeachGrade = "C-";
const D: Thames21RapidAppraisalBeachGrade = "D";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Thames21RapidAppraisalBeachGradeEnum = {
  ...createEnum("Thames21RapidAppraisalBeachGrade", [
    [A, "A"],
    [BPlus, "B+"],
    [B, "B"],
    [BMinus, "B-"],
    [CPlus, "C+"],
    [C, "C"],
    [CMinus, "C-"],
    [D, "D"],
  ]),
  A,
  BPlus,
  B,
  BMinus,
  CPlus,
  C,
  CMinus,
  D,
};

export default Thames21RapidAppraisalBeachGradeEnum;
